import { render, staticRenderFns } from "./TaskArchive.vue?vue&type=template&id=a3e982fc&scoped=true"
import script from "./TaskArchive.vue?vue&type=script&lang=js"
export * from "./TaskArchive.vue?vue&type=script&lang=js"
import style0 from "./TaskArchive.vue?vue&type=style&index=0&id=a3e982fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e982fc",
  null
  
)

export default component.exports